import { render, staticRenderFns } from "./Dashboard404.vue?vue&type=template&id=4781d9e4&scoped=true"
import script from "./Dashboard404.vue?vue&type=script&lang=js"
export * from "./Dashboard404.vue?vue&type=script&lang=js"
import style0 from "./Dashboard404.vue?vue&type=style&index=0&id=4781d9e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781d9e4",
  null
  
)

export default component.exports